import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

// Theme
import Theme from 'theme'

// Componentes

// Pages
// import HomePage from 'pages/home'
import OffertsPage from 'pages/offerts'

const App = () => {
  return (
    <Theme>
      <Routes>
        {/* <Route exact path='/' element={<HomePage />} /> */}
        <Route exact path='/offerts/:format' element={<OffertsPage />} />

        <Route path='*' element={<Navigate to='/offerts/6' />} />
      </Routes>
    </Theme>
  )
}

export default App
